import * as doi from './doi';
import * as isbn from './isbn';
import * as pubmed from './pubmed';
import * as url from './url';

export { doi, isbn, pubmed, url };
